export default "__VITE_ASSET__CJ31bJc0__"